export default "__VITE_ASSET__CZT4OVl5__"